<template>
  <el-row :gutter="10">
    <el-col :xs="24" :sm="10" class="mb-10px">
      <CheckinStat :dialogVisible="dialogVisible"
                 @openDialog="dialogVisible = true"
                 @setEmployees="employees = $event"
                 @setDetailLoading="detailLoading = $event"
                 @setDetailData="setDetailData"/>
    </el-col>
    <el-col :xs="24" :sm="14">
      <CheckinDetail :detailLoading="detailLoading"
              :report_date="report_date"
              :show_type="show_type"
              :tableData="tableData"/>
    </el-col>
  </el-row>
</template>

<script>
import CheckinStat from "./CheckinStat";
import CheckinDetail from "./CheckinDetail";
import {setNavTitle} from "@/views/useNavTitle";

export default {
  name: "CheckinLog",
  components: {
    CheckinDetail,
    CheckinStat,
  },
  mounted() {
    setNavTitle("去打卡")
  },
  methods: {
    setDetailData({report_date, tableData, show_type}) {

      this.report_date = report_date;
      this.show_type = show_type;
      this.tableData = tableData;
    },
    numberFormatter(row, column /* , cellValue, index */) {
      const number = row[column.property];
      return new Intl.NumberFormat().format(number);
    },
    handleClose() {
      this.dialogVisible = false;
    }
  },
  data() {
    return {
      tableData: this.tableData || [],
      employees: this.employees || [],
      detailLoading: false,
      dialogVisible: false,
      report_date: undefined,
      show_type: "所有", // 所有 . 體溫正常 . 疑似發燒
    };
  },
};
</script>

<style scoped>

</style>
